import { render } from "./Document.vue?vue&type=template&id=db575ce6"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
script.render = render

export default script